import { lazy, useMemo } from "react";
import { Navigate, type RouteObject } from "react-router";
import { useBerechtigt } from "../../components/Guard";

const TestSzenarioListe = lazy(() => import("./TestSzenarioListe"));
const TestSzenarioDetailsServoTypen = lazy(
  () => import("./TestSzenarioDetailsServoTypen")
);
const TestSzenarioWrapper = lazy(() => import("./TestSzenarioWrapper"));
const TestSzenarioBearbeiten = lazy(() => import("./bearbeiten"));
const TestSzenarioDetailsVersionen = lazy(
  () => import("./TestSzenarioDetailsVersionen")
);

export function useTestSzenarioRoutes(): Array<RouteObject> {
  const enabled = useBerechtigt({ berechtigung: "test-szenario:liste" });

  return useMemo(
    () =>
      enabled
        ? [
            {
              path: "test-szenarios",
              children: [
                { index: true, element: <TestSzenarioListe /> },
                { path: "neu", element: <TestSzenarioListe /> },
                {
                  path: ":testSzenarioId",
                  element: <TestSzenarioWrapper />,
                  children: [
                    {
                      index: true,
                      element: <Navigate to="versionen/all" replace />,
                    },
                    {
                      path: "servo-typen",
                      element: <TestSzenarioDetailsServoTypen />,
                    },
                    { path: "bearbeiten", element: <TestSzenarioBearbeiten /> },
                    {
                      path: "versionen",
                      children: [
                        {
                          path: ":testSzenarioVersionId",
                          index: true,
                          element: <TestSzenarioDetailsVersionen />,
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ]
        : [],
    [enabled]
  );
}
